import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import placeholder from 'lib/placeholder';
import { trackEvent } from 'lib/posthog';

import { CLICK_COUPON_CTA } from 'constants/analytics';

const APP_SMARTLINK = process.env.NEXT_PUBLIC_COUPONS_LIST_APP_SMARTLINK;

const AppDownloadCtaCard = () => {
  const handleClick = () => {
    trackEvent(CLICK_COUPON_CTA, {
      option: 'app_download',
    });

    window.open(APP_SMARTLINK, '_blank', 'noopener,noreferrer');
  };

  if (!APP_SMARTLINK) return null;

  return (
    <Box className="grid min-h-36 grid-cols-[96px_1fr] gap-x-6 gap-y-2 rounded-4 border-2 border-primary-300 p-4 dark:border-primary-300 md:hidden">
      <div className="row-span-2 flex h-24 w-24 flex-col items-center justify-center self-center border-r border-dashed border-neutral-high-400 pr-6 dark:border-neutral-low-200">
        <Heading
          as="h3"
          className="cursor-pointer text-center text-neutral-low-400 dark:text-neutral-high-200"
          size="size2"
          onClick={handleClick}
        >
          APP
        </Heading>
        <Text
          className="cursor-pointer text-center text-neutral-low-400 dark:text-neutral-high-200"
          size="size1"
          onClick={handleClick}
        >
          VIP
        </Text>
      </div>
      <div className="col-start-2 row-span-2 flex flex-col gap-2 self-center">
        <Text
          className="cursor-pointer text-sm font-semibold text-neutral-low-400 dark:text-neutral-high-200"
          size="size3"
          onClick={handleClick}
        >
          {placeholder('descriptions.couponAppDownloadCta')}
        </Text>
        <Button
          buttonTextClassName="text-sm"
          className="h-8 w-full self-center min-size-8"
          size="size3"
          type="primary"
          full
          onClick={handleClick}
        >
          {placeholder('actions.couponAppDownloadCta')}
        </Button>
      </div>
    </Box>
  );
};

export default AppDownloadCtaCard;
